





























































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  DefaultScreenSaver,
  FallbackScreenSaver,
  ScreenSaverType,
  ScreenSaverData,
  isDefaultScreenSaver,
  isFallbackScreenSaver,
} from '@/app/shared/utilities/static-types';

@Component({
  name: 'ViewScreenSaver',
})
export default class ViewScreenSaver extends Vue {
  @Prop() public screenSaver!: ScreenSaverData;
  @Prop() public screenSaverType!: ScreenSaverType;
  public closeEvent = 'update:showViewScreenSaver';

  public get isFallbackScreenSaver(): boolean {
    return this.screenSaverType === ScreenSaverType.FALLBACK_SCREEN_SAVER;
  }

  public get screenSaverTitle(): string {
    if (this.isFallbackScreenSaver) {
      return this.$t('view_fallback_screen_saver').toString();
    }
    return this.$t('view_screen_saver').toString();
  }

  public get fallbackScreenSaver(): FallbackScreenSaver {
    return this.screenSaver as FallbackScreenSaver;
  }

  public get regularScreenSaver(): DefaultScreenSaver {
    return this.screenSaver as DefaultScreenSaver;
  }
}
